module.exports = __webpack_public_path__ + "img/workplan-individ.jpg?81f84e602f9a89d2db95c1af03a466e1";